import * as React from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { useOfferContext } from '../../../context';
import {
  getRentPrice,
  getMoreRentPrice,
  getFee,
  getClientFee,
  getDeposit,
  getAgentBonus,
  getSalePrice,
  getSalePricePerMeter,
  getCommercialRentPrice,
  getCommercialPerMeterByYear,
  getCommercialLandPerMeterByYear,
  getSaleType,
  isCommercial,
  isCommercialLand,
  isRent,
  isSuburban,
} from '../../../utils/offers';
import { Price } from 'shared/components/OfferCard/Price';
import { selectUser } from 'shared/slices';

export const OfferPriceContainer = () => {
  const { offer } = useOfferContext();
  const user = useSelector(selectUser, shallowEqual);

  const {
    bargainTerms,
    dealType,
    category,
    totalArea,
    offerType,
    priceTotalPerMonthRur,
    pricePerUnitAreaPerYearRur,
    land,
  } = offer;

  const terms = React.useMemo(() => {
    if (isCommercial(offerType ?? undefined) || isCommercialLand(category)) {
      const terms = [];
      if (isRent(dealType ?? undefined)) {
        terms.push(getCommercialRentPrice(category, priceTotalPerMonthRur ?? undefined));
        if (isCommercialLand(category)) {
          terms.push(
            getCommercialLandPerMeterByYear({
              pricePerUnitAreaPerYearRur: pricePerUnitAreaPerYearRur ?? undefined,
              land: land ?? undefined,
            }),
          );
        } else {
          terms.push(getCommercialPerMeterByYear(pricePerUnitAreaPerYearRur ?? undefined));
        }

        return terms;
      }

      return [
        getSalePrice(bargainTerms ?? undefined),
        getSalePricePerMeter({ bargainTerms: bargainTerms ?? undefined, totalArea: Number(totalArea) }),
        getSaleType(bargainTerms ?? undefined),
      ];
    }

    if (isRent(dealType ?? undefined)) {
      return [
        getRentPrice(category, bargainTerms ?? undefined),
        getMoreRentPrice(category, bargainTerms ?? undefined),
        user.isAuthenticated && Boolean(user.isAgent)
          ? getFee(bargainTerms ?? undefined)
          : getClientFee(bargainTerms ?? undefined),
        getDeposit(bargainTerms ?? undefined),
        getAgentBonus(user, bargainTerms ?? undefined),
      ];
    }

    const priceData = [getSalePrice(bargainTerms ?? undefined)];

    if (isSuburban(category)) {
      priceData.push(
        getSalePricePerMeter({ bargainTerms: bargainTerms ?? undefined, totalArea: Number(totalArea) }) as string,
      );
    }

    priceData.push(getAgentBonus(user, bargainTerms ?? undefined));

    return priceData;
  }, [
    bargainTerms,
    category,
    dealType,
    land,
    offerType,
    pricePerUnitAreaPerYearRur,
    priceTotalPerMonthRur,
    totalArea,
    user,
  ]);

  if (!bargainTerms) {
    return null;
  }

  return <Price terms={terms} />;
};
